import { memo } from 'react';
import { ossPrefix } from '@/constant';
import cx from './index.module.scss';

const EMPTY_START = ossPrefix + '/index_module/index/lx080c08_715592.png';

// 1🌟到5🌟
const STAR_LIST = [
  ossPrefix + '/index_module/index/lx07w37h_517565.png',
  ossPrefix + '/index_module/index/lx07w37i_517565.png',
  ossPrefix + '/index_module/index/lx07w37j_517565.png',
  ossPrefix + '/index_module/index/lx07w37l_517565.png',
  ossPrefix + '/index_module/index/lx07w37k_517565.png',
];

const SCORE_STAR_2_TEXT = {
  1: '不满意',
  2: '不满意',
  3: '一般般',
  4: '很满意',
  5: '很满意',
};

const ScoreStar = (props: {
  score: number;
  size?: 'small' | 'huge';
  handleClick?: (score: number) => void;

  widthEvaluate?: boolean;
}) => {
  const currentSize = props.size || 'small';

  const renderStar = [...Array(5)].map((_, index) => {
    if (index < props.score) {
      return (
        <img
          key={index}
          src={STAR_LIST[index]}
          className={cx(`star-${currentSize}`)}
          onClick={() => props?.handleClick?.(index + 1)}
        />
      );
    }
    return (
      <img
        key={index}
        src={EMPTY_START}
        className={cx(`star-${currentSize}`)}
        onClick={() => props?.handleClick?.(index + 1)}
      />
    );
  });

  return (
    <div className={cx('container')}>
      {renderStar}
      {props?.widthEvaluate && <span className={cx('evaluate')}>{SCORE_STAR_2_TEXT[props?.score]}</span>}
    </div>
  );
};

export default memo(ScoreStar);
